// extracted by mini-css-extract-plugin
module.exports = {"buttonRound":"ButtonRound_buttonRound__GWvfx"};